export const ACTION_GET_ADDRESS_DATASOURCES = '/Address/GetAddressDatasource';